import { render, staticRenderFns } from "./memberRightTable.vue?vue&type=template&id=484fd4dc&scoped=true"
import script from "./memberRightTable.vue?vue&type=script&lang=js"
export * from "./memberRightTable.vue?vue&type=script&lang=js"
import style0 from "./memberRightTable.vue?vue&type=style&index=0&id=484fd4dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fd4dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484fd4dc')) {
      api.createRecord('484fd4dc', component.options)
    } else {
      api.reload('484fd4dc', component.options)
    }
    module.hot.accept("./memberRightTable.vue?vue&type=template&id=484fd4dc&scoped=true", function () {
      api.rerender('484fd4dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberNew/components/memberRightTable.vue"
export default component.exports